<template>
  <div>
    <v-row v-if="!loading">
      <v-col
        v-for="(item, index) in items"
        :key="index"
        cols="12"
        :sm="fullWidth ? 12 : 6"
        :md="fullWidth ? 12 : 4"
        :lg="fullWidth ? 12 : 4"
        :xl="fullWidth ? 12 : 3"
      >
        <ProjCard
          v-model="item.src"
          :title="item.name"
          :subtitle="item.projRole"
          :btn="item.btn"
          :building="item.building"
          :checkedIn="item.checkedIn"
          :id="item.id"
          :projTypeId="item.projTypeId"
          :imageSrc="item.defaultImage"
          @click="clickCard(item)"
        >
          <template v-slot:btn>
            <slot name="btn" :project="item"></slot>
          </template>

          <template v-slot:btnLeftDown>
            <slot name="btnLeftDown" :project="item"></slot>

            <span v-if="item.isFavourite" class="mr-2">
              <v-chip>
                <v-icon color="success"> mdi-star </v-icon>
              </v-chip>
            </span>
            <span v-if="item.psiConfirmed" class="mr-2">
              <v-chip>
                <v-icon left color="primary"> mdi-check-decagram </v-icon>
                PSI
              </v-chip>
            </span>
            <span v-if="item.id === bookingActive.projectId">
              <v-chip color="primary">
                <v-icon> mdi-calendar-check </v-icon>
              </v-chip>
            </span>
          </template>
          <template v-slot:btnRightDown>
            <slot name="btnRightDown" :project="item"></slot>
          </template>
        </ProjCard>
      </v-col>
    </v-row>

    <v-row v-if="loading">
      <v-col
        v-for="index in 4"
        :key="index"
        cols="12"
        :sm="fullWidth ? 12 : 6"
        :md="fullWidth ? 12 : 4"
        :lg="fullWidth ? 12 : 4"
        :xl="fullWidth ? 12 : 3"
      >
        <ProjCard :loading="loading" />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ProjCard from "@/components/shared/cards/ProjCard.vue";
import { mapGetters } from "vuex";

interface listObject {
  title?: string;
  subtitle?: string;
  src?: string;
  btn?: string;
  building?: boolean;
}

export default Vue.extend({
  name: "ProjCards",
  props: {
    value: {
      type: Array as () => Array<listObject>,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickCard(item) {
      this.$emit("click", item);
    },
  },
  computed: {
    ...mapGetters({
      bookingActive: "profile/bookingActive",
    }),
    items: {
      get(): Array<listObject> {
        return this.value;
      },
    },
  },
  components: {
    ProjCard,
  },
});
</script>
